import { Decoration, DText, Flex, Padding } from "../../../styles/CommonStyles"
import { ProfileInfoItem, ProfileInfoAnimate } from "../../../styles/main/profile"
import Text from "../../../core/utils/Text"
import { fadeVariants } from "../../../core/utils/theme"
import useGetProfileOrUser from "../../../core/hooks/main/users/useGetProfileOrUser"
import { UserStatus } from "../../../styles/main/profile"

const ProfileInfo = ({
    detail = false,
    user
}) => {

    const { profile } = useGetProfileOrUser(detail, user)

    if (!profile) return null

    const EMAIL_VERIFIED = !!profile.email_verified_at
    const MOBILE_VERIFIED = !!profile.mobile_verified_at

    const info = {
        name: profile.name,
        email: profile.email,
        gender: profile.gender,
        language: profile.language,
        date_of_birth: profile.date_of_birth,
        referral_code: profile.referral_code,
        telegram_chat_id: profile.telegram_chat_id,
        timezone: profile.timezone,
        theme: profile.preferences?.theme,
        notifications: profile.preferences?.notifications ? 'enabled' : 'disabled',
        wallet_balance: profile.wallet?.balance,
        created_at: profile.created_at
    }

    return (
        <ProfileInfoAnimate
            variants={fadeVariants}
            animate='in'
            exit='out'
            initial='out'
        >
            <Padding padding={'20px'}>

                <Flex>
                    <Decoration />
                    <DText main>
                        <Text tid='profile-info' />
                    </DText>
                </Flex>
                <Flex justify="start" fw wrap>

                    {Object.entries(info).map(([key, value]) => (
                        <ProfileInfoItem key={key}>
                            <DText main className="opacity-70">{key}</DText>
                            <div className="p-3 border border-gray-400/50 rounded-lg">
                                <DText main>
                                    {value ?? '--'}
                                </DText>
                            </div>
                        </ProfileInfoItem>
                    ))}
                    <ProfileInfoItem>
                        <DText main className="opacity-70">email-status</DText>
                        <UserStatus active={EMAIL_VERIFIED} className="max-w-max">
                            <Text tid={EMAIL_VERIFIED ? 'verified' : 'not-verified'} />
                        </UserStatus>
                    </ProfileInfoItem>

                    <ProfileInfoItem>
                        <DText main className="opacity-70">mobile-status</DText>
                        <UserStatus active={MOBILE_VERIFIED} className="max-w-max">
                            <Text tid={MOBILE_VERIFIED ? 'verified' : 'not-verified'} />
                        </UserStatus>
                    </ProfileInfoItem>
                </Flex>

            </Padding>
        </ProfileInfoAnimate>
    )
}

export default ProfileInfo